/* Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved. */

// Rotates through the existing accent-* design tokens (tok-040) so property
// categories read as visually distinct in list views, without maintaining an
// exhaustive category→color map that would need updating for every new category.
const CATEGORY_ACCENTS = [
  'var(--accent-terracota)',
  'var(--accent-petroleo)',
  'var(--accent-ambar)',
  'var(--accent-salvia)',
  'var(--accent-ameixa)',
  'var(--accent-marinho)',
  'var(--accent-cobre)',
  'var(--accent-oliva)',
  'var(--accent-mostarda)',
  'var(--accent-uva)',
] as const;

/**
 * Deterministically maps a property category to one of the accent tokens,
 * so the same category always renders with the same color.
 *
 * @param category - Raw or localized category value (e.g. "Apartamento").
 * @returns A `var(--accent-*)` color for use as a dot, border, or icon tint.
 */
export function getCategoryAccentColor(category: string | null | undefined): string {
  if (!category) return 'var(--text-tertiary)';
  let hash = 0;
  for (let i = 0; i < category.length; i += 1) {
    /**
     * One step of a simple string hash: multiply the running total by 31
     * and fold in the next character code.
     */
    hash = (hash * 31 + category.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % CATEGORY_ACCENTS.length;
  return CATEGORY_ACCENTS[index];
}
